<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Save"
		v-on:confirm="save"
		v-on:closeModal="closeModal">

		<field 
			label="Name" 
			col-class="col-sm-5" 
			v-model="payload.name"
			:invalid="$store.errorList.name">
		</field>

		<field
			label="Category"
			col-class="col-sm-5"
			v-model="payload.category_id"
			:invalid="$store.errorList.category_id"
			:params="{type:'select',options:categoryOptions}">
		</field>

		<form-group label="Charge Out Rates"
			col-class="col-sm-5">

			<label v-for="(rate,key) in chargeOutRates" 
				class="d-flex align-items-center">
				<input type="checkbox" class="mr-2" v-model="chargeOutRates[key].enabled">

				<field v-if="chargeOutRates[key].enabled"
					style="width: 120px;"
					:params="{type:'number',min:0,step:0.01,disabled:true}"
					v-model="chargeOutRates[key].rate">
				</field>

				<div class="rate-label ml-2">$/{{ key }}</div>
			</label>

		</form-group>
		
		<field 
			:label="'Cost per '+timeUnitLabel" 
			col-class="col-sm-5" 
			:params="{type:'number',min:0,step:0.01}"
			v-model="payload.default_cost_hr"
			:invalid="$store.errorList.default_cost_hr">
		</field>

		<field 
			label="Odometer Unit" 
			col-class="col-sm-5" 
			:params="{type:'select',options: [
				{value: 'km',text:'km'},
				{value: 'mi',text:'mi'},
				{value: 'hrs',text:'hrs'}
			]}"
			v-model="payload.odo_unit"
			:invalid="$store.errorList.odo_unit">
		</field>

		<field 
			label="Type Colour" 
			col-class="col-sm-5" 
			v-model="payload.color_hex" 
			:params="{type: 'color'}">
		</field>

		<form-group 
			label="Type Icon" 
			col-class="col-sm-5">

			<div v-if="!selectingIcon" class="d-flex align-items-center">
				<i class="fa fa-2x mr-4" :class="payload.icon"></i>

				<button  
					type="button" 
					class="btn btn-sm btn-light" 
					v-on:click="selectingIcon = true">
						Select Icon...
				</button>
			</div>
			<div v-else>
				<div class="row">
					<div v-for="icon in icons" class="col-3">
						<i class="fa fa-3x icon-button" :class="icon" v-on:click="iconSelected(icon)"></i>
					</div>
				</div>
			</div>
		</form-group>

		<field 
			label="Maintenance Events" 
			col-class="col-sm-5" 
			v-model="applicableMaintenanceEvents" 
			:params="{
				type: 'select-multi',
				options: maintenanceEventTypeOptions
			}">
		</field>

		<hr>

		<custom-fields-list
			:custom-fields="customFields"
			v-on:change="customFieldsChange">
		</custom-fields-list>

	</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import FormGroup from "../FormGroup"
import draggable from "vuedraggable"
import CustomFieldsList from "@/components/super_components/CustomFieldsList"

export default {
	name: "EquipmentTypeEditModal",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		draggable,
		CustomFieldsList
	},
	props: ["visible","title","record"],
	data() {
		return {
			payload: {},
			customFields: [],
			applicableMaintenanceEvents: [],
			customFields: [],
			showAddForm: false,
			editingAddForm: false,
			editFormIndex: null,
			maintenanceEvents: [],
			chargeOutRates: {
				hour: {
					enabled: true,
					rate: 0.00
				},
				day: {
					enabled: true,
					rate: 0.00
				},
				week: {
					enabled: true,
					rate: 0.00
				},
				month: {
					enabled: true,
					rate: 0.00
				},
			},
			selectingIcon: false,
			addForm: {
				type: '',
				label: '',
				required: false,
				showInList: false,
				showOnCompanyForm: false
			},
			typeOptions: [
				{text: 'Text',value:'text'},
				{text: 'Date',value:'date'},
				{text: 'Number',value:'number'},
				{text: 'Province/State',value:'province'},
				{text: 'Select',value:'select'},
				{text: 'Boolean',value:'boolean'}
			],
			icons: [
				"fa-truck",
				'fa-truck-pickup',
				'fa-snowplow',
				'fa-truck-monster',
				'fa-truck-moving',
				'fa-tractor',
				'fa-trailer',
				'fa-car-battery',
				'fa-bolt',
				'fa-tools',
				'fa-screwdriver',
				'fa-hammer',
				'fa-camera',
				'fa-solar-panel',
				'fa-oil-can',
				'fa-fan',
				'fa-toolbox',
				'fa-pallet',
				'fa-dumpster',
				'fa-brush'
			]
		}
	},
	watch: {
		visible() {
			this.setPayload()
			this.setCustomFieldsList()
		},
		record() {
			this.setPayload()
			this.setCustomFieldsList()
		}
	},
	computed: {
		timeUnitLabel() {
			if (this.payload.charge_out_rate_unit == 'days')
				return "Day"
			else
				return "Hour"
		},
		categoryOptions() {
			return this.optionify(this.$store.equipmentCategories,"name")
		},
		maintenanceEventTypeOptions() {
			return this.optionify(this.maintenanceEvents,"title")
		},
		iconOptions() {
			return [
				{
					text: '<i class="fa fa-truck"></i> Truck',
					value: 'fa-truck' 
				}
			]
		}
	},
	methods: {
		setPayload() {
			this.payload = this.cloneObj(this.record)

			if (!this.record.charge_out_rate_unit)
				this.payload.charge_out_rate_unit = "hrs"

			if ("EquipmentMaintenanceEventType" in this.record && this.record.EquipmentMaintenanceEventType) 
				this.applicableMaintenanceEvents = this.record.EquipmentMaintenanceEventType.map(event => event.id)
			let chargeOutRates = false
			try {
				chargeOutRates = JSON.parse(this.record.charge_out_rates_json)
			}
			catch (e) {}

			if (!chargeOutRates) {
				//set it up manually from the old field
				chargeOutRates = {
					hour: {enabled: false,rate: 0},
					day: {enabled: false,rate: 0},
					week: {enabled: false,rate: 0},
					month: {enabled: false,rate: 0}
				}

				if (this.payload.charge_out_rate_unit == 'days') {
					chargeOutRates.day = {
						enabled: true,
						rate: this.payload.charge_out_rate
					}
				}
				else {
					chargeOutRates.hour = {
						enabled: true,
						rate: this.payload.charge_out_rate
					}
				}
			}

			this.chargeOutRates = chargeOutRates
		},
		customFieldsChange(newFields) {
			this.customFields = newFields

			let chargeOutRates = false
			try {
				chargeOutRates = JSON.parse(this.record.charge_out_rates_json)
			}
			catch (e) {}

			if (!chargeOutRates) {
				//set it up manually from the old field
				chargeOutRates = {
					hour: {enabled: false,rate: 0},
					day: {enabled: false,rate: 0},
					week: {enabled: false,rate: 0},
					month: {enabled: false,rate: 0}
				}

				if (this.payload.charge_out_rate_unit == 'days') {
					chargeOutRates.day = {
						enabled: true,
						rate: this.payload.charge_out_rate
					}
				}
				else {
					chargeOutRates.hour = {
						enabled: true,
						rate: this.payload.charge_out_rate
					}
				}
			}

			this.chargeOutRates = chargeOutRates
		},
		setCustomFieldsList() {

			if ("custom_fields_json" in this.record && this.record.custom_fields_json.length > 2) {
				try {
					this.customFields = JSON.parse(this.record.custom_fields_json)
				}
				catch (e) {
					this.customFields = []
				}
			}
			else
				this.customFields = []
		},
		iconSelected(icon) {
			this.payload.icon = icon
			this.selectingIcon = false
		},
		save() {
			let vm = this

			this.payload.custom_fields_json = JSON.stringify(this.customFields)
			this.payload.charge_out_rates_json = JSON.stringify(this.chargeOutRates)

			this.payload.EquipmentMaintenanceEventType = this.applicableMaintenanceEvents

			this.saveRecord("EquipmentType",this.payload,response => {
				vm.alertSaved("Equipment saved!")

				vm.getJSON("EquipmentType/find/" + this.record.slug).then(response => {

					if (response.success) {
						vm.$emit("modelChanged",response.data)
					}
				})
				vm.$emit("closeModal")
				
			})
		},
		closeModal() {
			this.payload = {}
			this.$emit("closeModal")
			
		},
		fetchCategories() {
			this.fetchModel("EquipmentCategory","equipmentCategories",false)
		},
		fetchMaintenanceEvents() {
			let vm = this
			this.getJSON("EquipmentMaintenanceEventType/get").then(response => {
				if (response.success)
					vm.maintenanceEvents = response.data
			})
		}
	},
	created() {
		this.setPayload()

		this.setCustomFieldsList()

		if (this.$store.equipmentCategories.length == 0)
			this.fetchCategories()

		if (this.maintenanceEvents.length == 0)
			this.fetchMaintenanceEvents()
	}
}
</script>